export default {
  mediaPreviewAltText: 'preview media',
};
